import {removeDiacritics} from "../helpers/stringHelpers";
import {methods as MorseMethods} from "./morse";
const Morse = {
    cyp: {
        a: '.-',
        b: '-...',
        c: '-.-.',
        d: '-..',
        e: '.',
        f: '..-.',
        g: '--.',
        h: '....',
        '*': '----',
        i: '..',
        j: '.---',
        k: '-.-',
        l: '.-..',
        m: '--',
        n: '-.',
        o: '---',
        p: '.--.',
        q: '--.-',
        r: '.-.',
        s: '...',
        t: '-',
        u: '..-',
        v: '...-',
        w: '.--',
        x: '-..-',
        y: '-.--',
        z: '--..',
        0: '-----',
        1: '.----',
        2: '..---',
        3: '...--',
        4: '....-',
        5: '.....',
        6: '-....',
        7: '--...',
        8: '---..',
        9: '----.',
        '.': '.-.-.-',
        '!': '--..--',
        ',': '--..--',
        ';': '-.-.-.',
        '?': '..--..',
        '/': '-..-.',
        '=': '-...-',
        '-': '-....-',
        '(': '-.--.-',
        ')': '-.--.-',
        '"': '.-..-',
        ':': '---...',
        '_': '..--.-',
        ' ': ''
    },
    dec: {
        '.-': 'a',
        '-...': 'b',
        '-.-.': 'c',
        '-..': 'd',
        '.': 'e',
        '..-.': 'f',
        '--.': 'g',
        '....': 'h',
        '----': 'ch',
        '..': 'i',
        '.---': 'j',
        '-.-': 'k',
        '.-..': 'l',
        '--': 'm',
        '-.': 'n',
        '---': 'o',
        '.--.': 'p',
        '--.-': 'q',
        '.-.': 'r',
        '...': 's',
        '-': 't',
        '..-': 'u',
        '...-': 'v',
        '.--': 'w',
        '-..-': 'x',
        '-.--': 'y',
        '--..': 'z',
        '-----': '0',
        '.----': '1',
        '..---': '2',
        '...--': '3',
        '....-': '4',
        '.....': '5',
        '-....': '6',
        '--...': '7',
        '---..': '8',
        '----.': '9',
        '.-.-.-': '.',
        '--..--': ',!',
        '-.-.-.': ';',
        '..--..': '?',
        '-..-.': '/',
        '-...-': '=',
        '-....-': '-',
        '-.--.-': '()',
        '.-..-': '"',
        '---...': ':',
        '..--.-': '_',
        '': ' '
    }
}

const SEPARATOR = '/'
export const methods = {
    cypher: function (input, hasCh = false, missing = null, params, sep = SEPARATOR) {
        let string = []
        let cleaned = removeDiacritics(input).toLowerCase()
            .replace("ch", '*')
            .replace("  ", ' ')
            .replace(" . ", '.')
            .replace(".  ", '.')
        cleaned.split('').forEach((char) => {
            string.push(Morse.cyp[char]);
        })
        return string.join(sep);
    },
    decypher: function (input, hasCh = false, missing = null, params, sep = SEPARATOR) {
        let string = []
        input.split(sep).forEach((char) => {
            string.push(Morse.dec[char.trim()]);
        })
        return string.join('').replace('  ', '. ');
    },
    beepIt: async function (cyphered, dotDuration = Morse.getDotDuration) {
        return MorseMethods.beepIt(cyphered, dotDuration)
    },
    stopBeeping: function () {
        return MorseMethods.stopBeeping();
    }
};

export default {...methods,SEPARATOR}